import { ApplicationStore } from "src/store";
import { CountryCode } from "Types/api/Account";
import { isLockedPricingExperimentEnabled } from "./dealExperiments";

export const canShowMsrp = (state: ApplicationStore) => !!state.account?.integration_settings?.Financing?.ui?.show_msrp;

// Warning: in order for strikethrough to show up, MSRP needs to be !== price
export const canShowStrikeThroughMsrp = (state: ApplicationStore) =>
    !!state?.account?.integration_settings?.Financing.ui.strikethrough_msrp;

export const getCountry = (state: ApplicationStore): CountryCode => state.account?.address?.country || CountryCode.US;

export const IsCountryCanada = (state: ApplicationStore) => state.account?.address?.country === "CA";

export const IsCountryUS = (state: ApplicationStore) => state.account?.address?.country === "US";

export const hasSoftCreditIntegration = (state: ApplicationStore): boolean => {
    return !!state.account.integration_settings?.SoftCredit;
};

export const hasModernTradeInIntegration = (state: ApplicationStore): boolean => {
    return !!state.account.integration_settings?.TradeIn;
};

export const getAccountCountry = (state: ApplicationStore) => state.account.address?.country;

export const getAccountUrl = (state: ApplicationStore) => state.account.url;

export const getAccountSlug = (state: ApplicationStore) => state.account.slug;

// locked_pricing is a json_logic rule object not a boolean
export const isLockedPricingSetup = (state: ApplicationStore) =>
    isLockedPricingExperimentEnabled(state) || !!state.account.integration_settings?.locked_pricing;

export const getAccountZipCode = (state: ApplicationStore) => state.account.address?.zip!;

export const getAccountPhoneNumber = (state: ApplicationStore): string => state.account.phone ?? "";

export const isAccountLoading = (state: ApplicationStore) => state.account.loading;
